module.exports = __webpack_public_path__ + "img/music-work-icon6.c636b293.png";